module.exports = __webpack_public_path__ + "static/media/HSBCLogo.48a0a46f.svg";